export type variableFormatter = (longName: string) => string;

export class VariableFormatter {

  static formatTextVariable(longName: string): string {
    return `[%=${longName}%]`;
  }

  static formatUndefinedVariable(longName: string): string {
    return `[[[Undefined variable ${longName}]]]`;
  }

}




